// extracted by mini-css-extract-plugin
export default {"reportButton":"ReportCaseButton_reportButton__l21j+","mobile":"ReportCaseButton_mobile__ymi9k","content":"ReportCaseButton_content__Zq5vE","square":"ReportCaseButton_square__USXPF"};